export default __webpack_public_path__ + "static/media/sql_icon.5533e37b.webp";